// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"cf604d0c81d35852f0e3","731":"0fef88fac838bfd143e9","843":"d5b3898c07597ef4634f","883":"8408d6227f7ffffac9d9"}[chunkId] + ".js";
};